import { API_BASE_URL } from "./Constant";
import { dataDisplayRequest } from "../Auth/auth_service/AuthServiceHelper";
import { encryptData, decryptData } from "../Utils/Crypto";

/* Service layer class for all API related calls */
export default class AxiosService {
  getAllLabels(roles, status,selectedlanguage,userId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getLabelsByClientByStatus?role=${roles}&status=${status}&selectedLanguage=${selectedlanguage}&userId=${userId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  labelStatusUpdate(label, status,userId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/saveLabelStatus?labelId=${label}&status=${status}&userId=${userId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getLabelData(label) {
    // label = encryptData(label);
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getLabelDetails?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getComments(label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getAllCommentsByLabel?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  saveComment(data, label, username) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/saveComments?labelId=${label}&username=${username}`,
      data: data,
    };
    return dataDisplayRequest(config).then((response) => {

      return response;
    });
  }

  getMetaInfo(vendor) {
    const config = {
      method: "post",
      url: API_BASE_URL + "/metaInfo",
      data: { vendor: vendor },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  editComment(data,label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/editComment?labelId=${label}`,
      data: data,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  deleteComment(commentId,label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/deleteComment?labelId=${label}&commentId=${commentId}`,
      data:{},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getAllTreeComments(label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getAllTreeCommentsByLabel?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getValidationComment(label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getValidationComment?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  updateData(id, data, label,username) {

    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/updateData?labelId=${label}&username=${username}&jsonId=${id}`,
      data: data,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getLabelDataForDownload(label) {
    // label = encryptData(label);
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getLabelDataForDownload?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
   LogIndividualData(id, data, label,username) {

    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/LogIndividualData?labelId=${label}&username=${username}&jsonId=${encodeURIComponent(id)}`,
      data: data,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getEditedReportByLabel(label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getEditedReportByLabel?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getLabelDataForExcelDownload(label) {
    // label = encryptData(label);
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getLabelDataForExcelDownload?labelId=${label}`,
      data: {},
      responseType: 'arraybuffer'
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getDirectionForUseData(label) {
    // label = encryptData(label);
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getDirectionForUseDetails?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }


  getDirectionForUseDataCount(label) {
    // label = encryptData(label);
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getDirectionForUseDataCount?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getDirectionForUseDetailsWithPage(label, currentPage) {
    // label = encryptData(label);
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getDirectionForUseDetailsWithPage?labelId=${label}&currentPage=${currentPage}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  AcknowledgeDisclaimer(userId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/AcknowledgeDisclaimer?userId=${userId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  logTheLogout(userId) {
    // label = encryptData(label);
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/logTheLogout?userId=${userId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getCvAdditionComment(label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getCvAdditionComment?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }


  hideComment(commentId,label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/hideComment?labelId=${label}&commentId=${commentId}`,
      data:{},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  showAllComment(label, sectionNo) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/showAllComment?labelId=${label}&sectionNo=${sectionNo}`,
      data:{},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  fetchInputFiles(label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/fetchInputFiles?patentId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  //inputFileLink
  downloadFile(filename , label, userId) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/api/v1/download?fileName=${filename}&patentId=${label}&userId=${userId}`,
      data: {},
      responseType: "blob"
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

viewFile(fileName ,label ,userId) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/api/v1/view?fileName=${fileName}&patentId=${label}&userId=${userId}`,
      data: {},
     responseType: 'blob'
    };
    return dataDisplayRequest(config).then((response) => {
		return response;
	});
  }

  deleteFile(fileName, labelId, userId) {
    const config = {
      method: "delete",
      url: API_BASE_URL + `/api/v1/delete?fileName=${fileName}&patentId=${labelId}&userId=${userId}`,
    };
    return dataDisplayRequest(config).then(response => response);
  }

  getFieldCountByLabel(label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getFieldCount?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  generatePreviewUrl(label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/generatePreview?labelId=${label}`,
      data: {},
      timeout: 3000000
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  checkValidationOrCvPresent(label) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/checkValidationOrCvPresent?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getMasterLabelReport(userId) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getMasterLabelReport?userId=${userId}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getLabelRelatesToDetails(label) {
    // label = encryptData(label);
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/getLabelRelatesToDetails?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFieldVisibility() {
    const config = {
      method: "get",
      url: API_BASE_URL + `/api/v1/getFieldVisibility`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }


  getDynamicLabelConfig(roles) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/api/v1/getDynamicLabelConfig?role=${roles}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getLanguageDetails(label) {
    // label = encryptData(label);
    const config = {
      method: "get",
      url: API_BASE_URL + `/api/v1/getLanguageDetails?labelId=${label}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  searchInCVByLabelname(labelName, cvType, language){
    const config={
      method: "get",
      url: API_BASE_URL + `/api/v1/searchInCVByLabelname?labelName=${labelName}&cvType=${cvType}&language=${language}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  completeCVDetail(cvType,kuid){
    const config={
      method: "get",
      url: API_BASE_URL + `/api/v1/completeCVDetail?cvType=${cvType}&kuid=${kuid}`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  searchCVByKuId(cvType, value, language){
    const config={
      method: "post",
      url: API_BASE_URL + `/api/v1/searchCVByKuId`,
      data: {
        language:language,
        [cvType]:value,
      },
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

     clearProductPackage(label,userNmae,index) {
    const config = {
      method: "post",
      url: API_BASE_URL + `/api/v1/clearProductPackageData?labelId=${label}&username=${userNmae}&index=${index}`,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
    getAllCounties(){
    const config={
      method: "get",
      url: API_BASE_URL + `/api/v1/getAllCounties`,
      data: {},
    }
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  getCountryForSpecificUser(userId){
      const config={
      method: "get",
      url: API_BASE_URL + `/api/v1/getCountryForSpecificUser?userId=${userId}`,
      data: {},
    }
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
    getLabelForParticularUserAndLanguage(userId,territory,clientId){
      const config={
      method: "get",
      url: API_BASE_URL + `/api/v1/getLabelForParticularUserAndLanguage?userId=${userId}&territory=${territory}&clientId=${clientId}`,
      data: {},
    }
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  addLabelAndUploadInputFiles(formData, onProgress) {
    return dataDisplayRequest({
      method: "post",
      url: API_BASE_URL + `/api/v1/addLabelAndUploadInputFiles`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: e => {
        if (onProgress && e.total) {
          const percent = Math.round((e.loaded * 100) / e.total);
          onProgress(percent);
        }
      }
    }).then(response => {
      console.log('addLabelAndUploadInputFiles response:', response);
      return response;
    }).catch(error => {
      console.error('addLabelAndUploadInputFiles error:', error.response || error);
      throw error;
    });
  }


    getAllClientsNameForSpecificUser(userId){
      const config={
      method: "get",
      url: API_BASE_URL + `/api/v1/getAllClientsNameForSpecificUser?userId=${userId}`,
      data: {},
    }
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

   getTurnAroundTimeReport(fromDate,toDate,client,country){
      const config={
      method: "post",
      url: API_BASE_URL + `/api/v1/getTurnAroundTimeReport?fromDate=${fromDate}&toDate=${toDate}&client=${client}&country=${country}`,
      data: {},
    }
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  
  fetchRefDataClassification(){
      const config={
      method: "get",
      url: API_BASE_URL + `/api/v1/fetchRefDataClassification`,
      data: {},
    }
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  fetchRefDataValuesByClassification(classificationId, entityType = [], territory = "", searchTerm = ""){
      const config={
      method: "post",
      url: API_BASE_URL + `/api/v1/fetchRefDataValuesByClassification`,
      data: {
        classificationId: classificationId,
        entityType: Array.isArray(entityType) ? entityType : [entityType],
        territory: territory,
        searchTerm: searchTerm
      },
    }
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

   getAllUpdates(){
    const config={
      method: "get",
      url: API_BASE_URL + `/api/v1/getAllUpdates`,
      data: {},
    }
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

   getFileUploadLogLabel() {
    const config = {
      method: "get",
      url: API_BASE_URL + `/api/v1/getFileUploadLogLabel`,
      data: {},
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
}
